module.exports = __webpack_public_path__ + "img/wallet-stat.5bec86c9.svg";